import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderAuthModalDialog = () => openPopupHelper({ popupName: popupNames.AUTH_MODAL });
